import { LoadingOutlined, ZoomOutOutlined } from '@ant-design/icons'
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  message
} from 'antd'
import type { ColumnsType, SorterResult } from 'antd/es/table/interface'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import InstitutionUserService from '../../services/InstitutionUserService'
import { parseMoneyAmount } from '../../utils/parseMoneyAmount'
import { RefundStatsRangeAlert } from './RefundStatsRangeAlert'
import { downloadExcel } from '../../utils/downloadExcel'
import styles from '../../asserts/css/BiddersEligibleForRefund.module.css'

const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
// const { REACT_APP_API_BASE_URL } = process.env
interface DataType {
  index: any
  key: React.Key
  created_at: string
  type: string
  amount: number
  totalPayments: string
  amountRequestedToBeRefund: string
  amountRequestedToBeRefundedInProgressStatus: string
  TotalNumberOfApplicantRequestedRefund: string
  notRequestedBidders: string
  ref_number: string
  full_name: string
  phone_number: string
  expiration_date: string
  status: string
}

const BiddersEligibleForRefund: React.FC = () => {
  const [form] = Form.useForm()
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [bidGuaranteeList, setBidGuaranteeList] = useState([])
  const [clear, setClear] = useState(false)
  const [loading, setLoading] = useState(false)
  const [totalAmount, setTotalAmount] = useState(0)
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([])
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  // const [paginating, setPaginating] = useState<TablePaginationConfig>({
  //   current: 1,
  //   pageSize: 10,
  //   total: 0
  // })
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [propertyIDs, setPropertyIDs] = useState<string[]>([])
  const [statusBid, setStatusBid] = useState()
  const [selectedPID, setSeletedPID] = useState()
  const [token, setToken] = useState('')
  const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
  const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
  const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
  const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
  const [totalPaidForRange, setTotalPaidForRange] = useState('')

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-shadow
  const handleTableChange = (pagination: any) => {
    setPagination(pagination) // Update pagination state on page change
  }
  useEffect(() => {
    OnBidSecuritySearch()
    // eslint-disable-next-line
  }, [clear, pagination.current, pagination.pageSize, statusBid, selectedPID])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    async function fetchRefundStats () {
      setLoading(true)
      try {
        const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
        const biddersAmountRequestedToBeRefund = response.data?.biddersAmountRequestedToBeRefund
        setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
        const bailiffAmountRequestedToBeRefunded = response.data?.bailiffAmountRequestedToBeRefunded
        setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
        const newBiddersAmountRequestedToBeRefunded = response.data?.newBiddersAmountRequestedToBeRefunded
        setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
        const newBailiffAmountRequestedToBeRefunded = response.data?.newBailiffAmountRequestedToBeRefunded
        setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
        const tp = response.data?.totalPayments
        setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
      } catch (err) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        setError('Failed to fetch refund stats')
        // eslint-disable-next-line no-console
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    void fetchRefundStats()
  },
  [fromDate, toDate, token])

  useEffect(() => {
    const total = refundRequestList.reduce(
      (acc, curr) => {
        const amount = Number(curr.amount)
        return acc + (Number.isNaN(amount) ? 0 : amount)
      },
      0
    )
    setTotalAmount(total)
  }, [refundRequestList])
  const OnBidSecuritySearch = (event?: any): void => {
    setLoading(true)

    if (userInfo.role === 'SYSTEM ADMIN' || userInfo.role === 'MINIJUST FINANCE' || userInfo.role === 'SUPER ADMIN') {
      InstitutionUserService.viewEligibleForRefund(
        pagination.pageSize,
        pagination.current,
        event?.target?.value,
        statusBid,
        selectedPID
      )
        .then((res: any) => {
          if (res.status === 200) {
            setBidGuaranteeList(res?.data)
            const pIDSet = new Set<string>(
              res?.data.map((item: Record<string, any>) => item.property_id)
            )
            const uniquePIDs: string[] = Array.from(pIDSet)
            setPropertyIDs(uniquePIDs)
            setPagination((prev) => ({
              ...prev,
              total: res?.meta?.total
            }))
            setLoading(false)
          }
        })
        .catch((err: any) => {
          if (err?.message !== 'Operation canceled due to new request.') {
            void message.error(err?.message)
          }
          setLoading(false)
        })
    } else if (userInfo.role === 'INSTITUTION ADMIN' || userInfo.role === 'INSTITUTION USER' || userInfo.role === 'SUPER ADMIN') {
      InstitutionUserService.GetBidSecurityListInstitutions(
        pagination.pageSize,
        pagination.current,
        event?.target?.value,
        statusBid,
        selectedPID
      )
        .then((res: any) => {
          if (res.status === 200) {
            setBidGuaranteeList(res?.data)
            const pIDSet = new Set<string>(
              res?.data.map((item: Record<string, any>) => item.property_id)
            )
            const uniquePIDs: string[] = Array.from(pIDSet)
            setPropertyIDs(uniquePIDs)
            setPagination((prev) => ({
              ...prev,
              total: res?.meta?.total
            }))
            setLoading(false)
          }
        })
        .catch((err: any) => {
          if (err?.message !== 'Operation canceled due to new request.') {
            void message.error(err?.message)
          }
          setLoading(false)
        })
    }
  }

  const clearFilter = (): void => {
    form.resetFields()
    setSeletedPID(undefined)
    setStatusBid(undefined)
    setClear(true)
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        const pageNumber = (pagination.current !== 0) || 1
        const pageSize = (pagination.pageSize !== 0) || 10
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false
    },
    {
      title: 'Bidder',
      dataIndex: 'full_name',
      key: 'full_name',
      width: 200,
      render: (text: any, record: any) => <span>{record?.full_name.toUpperCase()}</span>,
      sorter: (a: any, b: any) => a?.full_name.localeCompare(b?.ref_number),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Phone No',
      dataIndex: 'phone_number',
      key: 'phone_number',
      render: (text: any, record: any) => <span>{record?.phone_number}</span>,
      ellipsis: true
    },
    {
      title: 'Property ID',
      dataIndex: 'property_id',
      render: (text: any, record: any) => <span>{record?.property_id}</span>,
      key: 'property_id',
      ellipsis: true
    },
    {
      title: 'Payer Code',
      dataIndex: 'payer_code',
      key: 'payer_code',
      render: (text: any, record: any) => <span>{record?.payer_code}</span>,
      sorter: (a: any, b: any) => a?.payer_code.localeCompare(b?.payer_code),
      sortOrder: sortedInfo.columnKey === 'ref_number' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Payment Channel',
      dataIndex: 'payment_channel',
      key: 'payment_channel',
      render: (text: any, record: any) => <span>{record?.payment_channel}</span>,
      sorter: (a: any, b: any) => a?.payment_channel.localeCompare(b?.payment_channel),
      sortOrder: sortedInfo.columnKey === 'payment_channel' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Payment Channel Name',
      dataIndex: 'payment_channel_name',
      key: 'payment_channel_name',
      render: (text: any, record: any) => <span>{record?.payment_channel_name}</span>,
      sorter: (a: any, b: any) => a?.payment_channel_name.localeCompare(b?.payment_channel_name),
      sortOrder: sortedInfo.columnKey === 'payment_channel_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Ref Number',
      dataIndex: 'ref_number',
      key: 'ref_number',
      render: (text: any, record: any) => <span>{record?.ref_number}</span>,
      sorter: (a: any, b: any) => a?.ref_number.localeCompare(b?.ref_number),
      sortOrder: sortedInfo.columnKey === 'ref_number' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Payment Date',
      dataIndex: 'payment_date_time',
      key: 'payment_date_time',
      render: (text: any, record: any) => (
        <span>{moment(record?.payment_date_time).format('YYYY-MM-DD HH:MM:SS')}</span>
      ),
      sorter: (a: any, b: any) => moment(a?.payment_date_time).unix() - moment(b?.payment_date_time).unix(),
      sortOrder: sortedInfo.columnKey === 'payment_date_time' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Details',
      dataIndex: 'details',
      width: 65,
      render: (text: any, record: any) => (
        <div className="icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            title="View Details" // Add title attribute for default tooltip
            onClick={() => {
              navigate('/view-bid-securities', { state: record })
            }}
          ></i>
          &nbsp;&nbsp;
          {userInfo?.role === 'INSTITUTION USER' &&
            record?.type !== 'PAYMENT' &&
            record?.used === false && (
              <>
                <i
                  className="fas fa-edit cursor-pointer icon-style"
                  title="Edit" // Optional: add title for other icons
                  onClick={() => {
                    editBidSecurity(record)
                  }}
                ></i>
                &nbsp;&nbsp;
              </>
          )}
          &nbsp;&nbsp;<i className="las la-file-prescription cursor-pointer icon-style text-base" title="More Info"></i>
        </div>
      )
    }
  ]

  const editBidSecurity = (record: any): void => {
    navigate('/create-bid-guarantee', { state: record })
  }

  // const handleChange: TableProps<DataType>['onChange'] = (pagination, _filters, sorter) => {
  //   setPagination(pagination)
  //   setSortedInfo(sorter as SorterResult<DataType>)
  // }

  const createInstitution = (): void => {
    navigate('/create-bid-guarantee')
  }

  const onPIDSelect = (event: any): void => {
    setSeletedPID(event)
  }

  const onStatusSelect = (event: any): void => {
    setStatusBid(event)
  }

  const columnsToDownload = [
    'full_name',
    'nid',
    'phone_number',
    'email',
    'created_at',
    'execution_case_no',
    'property_id',
    'name',
    'security_amount',
    'expiration_date',
    'ref_number',
    'type',
    'doc_number',
    'bs_expiration_date'
  ]

  const handleClearSelect = (field: string): void => {
    if (field === 'property') {
      setSeletedPID(undefined)
    } else if (field === 'status') {
      setStatusBid(undefined)
    }
  }

  return (
    <div className="w-full">
      {/* Add custom styles for table rows */}
      <style>{`
        .table-row-light {
          background-color: #ffffff;
        }
        .table-row-dark {
          background-color: #ffffff;
        }
        .table-row-light:hover,
        .table-row-dark:hover {
          background-color: #f9fafb !important;
        }
        .ant-table-thead > tr > th {
          background-color: #f8f8f8 !important;
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          font-weight: 600 !important;
          color: #374151 !important;
          font-size: 14px !important;
          text-align: left !important;
          padding: 12px 16px !important;
          font-family: 'Avenir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
        }
        .ant-table-thead > tr > th:last-child {
          border-right: none !important;
        }
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          padding: 12px 16px !important;
          text-align: left !important;
          font-size: 14px !important;
          color: #1f2937 !important;
        }
        .ant-table-tbody > tr > td:last-child {
          border-right: none !important;
        }
        .ant-table-column-sorter {
          color: #9ca3af !important;
          margin-left: 4px !important;
        }
        .ant-table-column-sorter-up,
        .ant-table-column-sorter-down {
          color: #9ca3af !important;
          font-size: 12px !important;
        }
        .ant-table-column-sorter-up.active,
        .ant-table-column-sorter-down.active {
          color: #374151 !important;
        }
      `}</style>

      {/* Enhanced page header */}
      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px'
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-bold flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)'
            }}>
              <span style={{ fontSize: '24px' }}>✅</span>
            </div>
            <div>
              <h2 className="text-title font-bold" style={{
                margin: 0,
                background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Eligible For Refund
              </h2>
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: '500'
              }}>
                Refund Eligibility Management • Financial Processing Dashboard
              </p>
            </div>
          </div>
          {userInfo?.role === 'INSTITUTION USER' && (
            <div className="md:w-1/5">
              <Button
                type="primary"
                size="large"
                className="w-full enhanced-button"
                style={{
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '600',
                  boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => {
                  createInstitution()
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)'
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)'
                }}
              >
                <div className="float-left">
                  <i className="fa-solid fa-plus-minus"></i>&nbsp;
                </div>
                <div className="text-base">➕ Add Bid Security</div>
              </Button>
            </div>
          )}
        </div>
      </div>
      <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
      {/* Enhanced stats section with hover effects - Responsive */}
      <div style={{
        padding: '20px',
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        margin: '0 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
      className={styles['stats-container']}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                New Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Remaining to Request
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                {Math.max(
                  0,
                  parseMoneyAmount(totalPaidForRange) - (parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))
                ).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Paid Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                {(parseMoneyAmount(totalPaidForRange)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={4} xxl={4}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Refunded Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                {(((parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))) - ((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded)) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded)))).toLocaleString()} Rwf
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="px-2">
        <div className="py-0 mb-0">
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            form={form}
          >
            <Card
              className="bg-gradient-to-r from-blue-50 to-indigo-50"
              style={{
                borderRadius: '12px',
                border: '1px solid #e0e7ff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} xl={9}>
                  <Form.Item
                    name="property"
                    label={
                      <span style={{
                        fontWeight: '600',
                        color: '#374151',
                        fontSize: '16px'
                      }}>
                        🏠 Property ID Filter
                      </span>
                    }
                  >
                    <Select
                      showSearch
                      onChange={onPIDSelect}
                      size="large"
                      value={selectedPID}
                      placeholder="Filter by Property ID"
                      allowClear
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease'
                      }}
                      onClear={() => {
                        handleClearSelect('property')
                      }}
                    >
                      {propertyIDs.map((pid) => (
                        <Select.Option key={pid} value={pid}>
                          {pid}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} xl={9}>
                  <Form.Item
                    name="status"
                    label={
                      <span style={{
                        fontWeight: '600',
                        color: '#374151',
                        fontSize: '16px'
                      }}>
                        📊 Bid Status Filter
                      </span>
                    }
                  >
                    <Select
                      onChange={onStatusSelect}
                      size="large"
                      value={statusBid}
                      placeholder="Filter by Bid Status"
                      allowClear
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease'
                      }}
                      onClear={() => {
                        handleClearSelect('status')
                      }}
                    >
                      <Select.Option value="WON">Won</Select.Option>
                      <Select.Option value="LOST">Lost</Select.Option>
                      <Select.Option value="ONGOING">Ongoing</Select.Option>
                    </Select>
                  </Form.Item>
                  {selectedPID !== undefined && statusBid !== undefined
                    ? (
                      <div className="flex flex-col md:flex-row justify-between pb-2.5 md:pb-0 gap-2">
                        <div>
                          Applied filters: <span className="font-medium">{selectedPID}, {statusBid}</span>
                        </div>
                        <div
                          className="bg-black text-center py-0.5 px-2.5 text-white rounded-sm font-medium cursor-pointer"
                          onClick={clearFilter}
                        >
                          Clear X
                        </div>
                      </div>)
                    : ('')}
                </Col>
                <Col xs={24} xl={6}>
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      className="w-full font-bold"
                      onClick={() => {
                        downloadExcel(columnsToDownload, bidGuaranteeList, 'bid securities')
                      }}
                      disabled={selectedPID === undefined || statusBid === undefined}
                      style={{
                        background: (selectedPID === undefined || statusBid === undefined)
                          ? '#d1d5db'
                          : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: '600',
                        boxShadow: (selectedPID === undefined || statusBid === undefined)
                          ? 'none'
                          : '0 4px 12px rgba(16, 185, 129, 0.3)',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (selectedPID !== undefined && statusBid !== undefined) {
                          e.currentTarget.style.transform = 'translateY(-1px)'
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)'
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedPID !== undefined && statusBid !== undefined) {
                          e.currentTarget.style.transform = 'translateY(0)'
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)'
                        }
                      }}
                    >
                      📊 DOWNLOAD
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
        <Card
          title={
            <div style={{
              background: 'var(--refund-theme-primary-soft)',
              color: '#111827',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <span>✅</span>
              List of Provided Bidders Eligible For Refund
            </div>
          }
          style={{
            marginTop: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
          }}
          headStyle={{
            background: 'transparent',
            borderBottom: '1px solid #e5e7eb',
            padding: '0'
          }}
        >
          {/* Enhanced search bar */}
          <div className="search-container" style={{
            width: '100%',
            marginBottom: 16,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flexWrap: 'wrap'
          }}>
            <Input
              size="large"
              placeholder="🔍 Quick search in the tables"
              prefix={<ZoomOutOutlined style={{ color: '#6b7280' }}/>}
              onChange={(e) => {
                OnBidSecuritySearch(e)
              }}
              style={{
                width: '300px',
                borderRadius: '8px',
                border: '2px solid #e5e7eb',
                transition: 'border-color 0.2s ease'
              }}
            />
          </div>
          {/* Responsive scroll for table on small devices */}
          <div className="overflow-x-auto md:overflow-x-visible">
            <Spin
              spinning={loading}
              indicator={antIcon}
              tip={
                <span style={{
                  color: '#37762f',
                  fontWeight: '500'
                }}>
                  🔄 Loading eligible bidders data...
                </span>
              }
            >
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <Table
                  columns={columns}
                  dataSource={bidGuaranteeList}
                  onChange={handleTableChange}
                  pagination={{
                    ...pagination,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    hideOnSinglePage: false,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showLessItems: true,
                    style: {
                      background: '#F5F5F5',
                      borderRadius: '8px',
                      padding: '12px',
                      border: '1px solid #e5e7eb',
                      marginTop: '16px'
                    }
                  }}
                  loading={loading}
                  scroll={{ x: 900 }}
                  style={{
                    minWidth: 900,
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                  }
                />
              </div>
            </Spin>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default BiddersEligibleForRefund
